<template>
    
  <VUEModal v-if="PopupUdmX" :Titolo="this.GetTraduzioneLabel('Generic','TKN_IMP_TEMP_ASSE_X',this.LinguaUtente)" :Altezza="'80px'" :Larghezza="'500px'" :PathLogo="require('@/assets/images/LogoDMS.png')" :Programma="'DMSEW'"
              @onClickChiudiModal="AnnullaPopupUdmX()">
    <template v-slot:Body>
      <div style="display: flex; flex-flow: row wrap; align-items: center; justify-content: space-between; height: 100%; padding-left: 30px; padding-right: 30px;">
        <div style="width: 25%">
          <input class="form-control" type="number" style="margin: 0px; width: 70%;" v-model="GraphData.AxisX.UdmX"/>
        </div>

        <div>
          <label style="font-weight:bold;margin: 0px">{{ this.GetTraduzioneLabel('UdmGenerali','TKN_GIORNI',this.LinguaUtente) }}</label>
          <input type="radio" id="RadioGiorni" name="RadioUdmX" style="margin: 0px; margin-left: 10px" :value="TipiUdmX.Giorni" v-model="GraphData.AxisX.TipoUdmX"/>
        </div>

        <div>
          <label style="font-weight:bold;margin: 0px">{{ this.GetTraduzioneLabel('UdmGenerali','TKN_ORE',this.LinguaUtente) }}</label>
          <input type="radio" id="RadioOre" name="RadioUdmX" style="margin: 0px; margin-left: 10px" :value="TipiUdmX.Ore" v-model="GraphData.AxisX.TipoUdmX"/>
        </div>

        <div>
          <label style="font-weight:bold;margin: 0px">{{ this.GetTraduzioneLabel('UdmGenerali','TKN_MINUTI',this.LinguaUtente) }}</label>
          <input type="radio" id="RadioMinuti" name="RadioUdmX" style="margin: 0px; margin-left: 10px" :value="TipiUdmX.Minuti" v-model="GraphData.AxisX.TipoUdmX"/>
        </div>
      </div> 
    </template>
    <template v-slot:Footer>
      <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:25%" @click="AnnullaPopupUdmX()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
      <button v-if="GraphData.UdmX > 0" type="button" class="btn btn-success" style="float:right;font-weight:bold;width:25%" @click="ConfermaPopupUdmX()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
    </template>
  </VUEModal>

  <VUEModal v-if="PopupImpostazioniAsseY" :Titolo="this.GetTraduzioneLabel('Generic','TKN_IMP_ASSE_Y',this.LinguaUtente)" Altezza="150px" Larghezza="500px" :PathLogo="require('@/assets/images/LogoDMS.png')" :Programma="'DMSEW'"
              @onClickChiudiModal="AnnullaPopupImpostazioniY()">
    <template v-slot:Body>      
      <div style="display: flex; flex-flow: column wrap; padding-left: 50px; padding-right: 50px">
        <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center; margin-bottom: 5px;">
          <p style="font-weight:bold;width: 40%; margin: 0px">{{ this.GetTraduzioneLabel('Generic','TKN_MINIMO',this.LinguaUtente) }}</p>
          <input class="form-control" style="width:30%; text-align: right;" type="number" step="0.1" v-model="GraphData.AxisY.Min">
          <p style="font-weight:bold;width: 15%; margin: 0px; margin-left: 10px">{{ MixInsGetUnitaDiMisuraAsseYCampRil() }}</p>
        </div>
        <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center; margin-bottom: 5px;">
          <p style="font-weight:bold;width: 40%; margin: 0px">{{ this.GetTraduzioneLabel('Generic','TKN_MASSIMO',this.LinguaUtente) }}</p>
          <input class="form-control" style="width:30%; text-align: right;" type="number" step="0.1" v-model="GraphData.AxisY.Max">
          <p style="font-weight:bold;width: 15%; margin: 0px; margin-left: 10px">{{ MixInsGetUnitaDiMisuraAsseYCampRil() }}</p>
        </div>
        <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center;">
          <p style="font-weight:bold;width: 40%; margin: 0px">{{ this.GetTraduzioneLabel('Generic','TKN_UNITA_PRINCIPALE',this.LinguaUtente) }}</p>
          <input class="form-control" style="width:30%; text-align: right;" type="number" step="0.1" v-model="GraphData.AxisY.Udm">
          <p style="font-weight:bold;width: 15%; margin: 0px; margin-left: 10px">{{ MixInsGetUnitaDiMisuraAsseYCampRil() }}</p>
        </div>
      </div>
    </template>
    <template v-slot:Footer>
      <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:25%" @click="AnnullaPopupImpostazioniY" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
      <button type="button" class="btn btn-success" style="float:right;font-weight:bold;width:25%" @click="ConfermaPopupImpostazioniY" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
    </template>
  </VUEModal>

  <VUEModal v-if="PopupAsseTemp" :Titolo="this.GetTraduzioneLabel('VUEFrameComponenteGraficoStorico','TKN_FRM_GRAF_STORICO_ASSI_IMP',this.LinguaUtente)" :Altezza="'150px'" :Larghezza="'500px'" :PathLogo="require('@/assets/images/LogoDMS.png')" :Programma="'DMSEW'"
              @onClickChiudiModal="AnnullaPopupAsseTemp" @onClickConfermaModal="ConfermaPopupAsseTemp">
    <template v-slot:Body>
      <div style="display: flex; flex-flow: column wrap; padding-left: 50px; padding-right: 50px">
        <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center; margin-bottom: 5px;">
          <p style="font-weight:bold;width: 40%; margin: 0px">{{ this.GetTraduzioneLabel('Generic','TKN_MINIMO',this.LinguaUtente) }}</p>
          <input class="form-control" style="width:30%; text-align: right;" type="number" step="0.1" v-model="GraphData.AxisYTemp.Min">
          <p style="font-weight:bold;width: 15%; margin: 0px; margin-left: 10px">[{{ this.GetTraduzioneLabel('UdmGenerali','TKN_SIMBOLO_GRADI',this.LinguaUtente) }}]</p>
        </div>
        <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center; margin-bottom: 5px;">
          <p style="font-weight:bold;width: 40%; margin: 0px">{{ this.GetTraduzioneLabel('Generic','TKN_MASSIMO',this.LinguaUtente) }}</p>
          <input class="form-control" style="width:30%; text-align: right;" type="number" step="0.1" v-model="GraphData.AxisYTemp.Max">
          <p style="font-weight:bold;width: 15%; margin: 0px; margin-left: 10px">[{{ this.GetTraduzioneLabel('UdmGenerali','TKN_SIMBOLO_GRADI',this.LinguaUtente) }}]</p>
        </div>
        <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center;">
          <p style="font-weight:bold;width: 40%; margin: 0px">{{ this.GetTraduzioneLabel('Generic','TKN_UNITA_PRINCIPALE',this.LinguaUtente) }}</p>
          <input class="form-control" style="width:30%; text-align: right;" type="number" step="0.01" v-model="GraphData.AxisYTemp.Ampiezza">
          <p style="font-weight:bold;width: 15%; margin: 0px; margin-left: 10px">[{{ this.GetTraduzioneLabel('UdmGenerali','TKN_SIMBOLO_GRADI',this.LinguaUtente) }}]</p>
        </div>
      </div>
    </template>
  </VUEModal>

  <VUEModal v-if="PopupAddRighello" :Titolo="this.GetTraduzioneLabel('Generic','TKN_DATI_RIGHELLO',this.LinguaUtente)" Altezza="140px" Larghezza="500px" :PathLogo="require('@/assets/images/LogoDMS.png')" :Programma="'DMSEW'"
              @onClickChiudiModal="AnnullaPopupAddRighello()">
    <template v-slot:Body>
      <div style="font-size:14px; display: flex; flex-flow: column nowrap; align-content: center; justify-content: center; align-items: center; margin-top: 15px; padding-left: 30px; padding-right: 30px;">
        <div style="width: 100%; display: flex; flex-flow: row wrap; justify-content: space-between;">
          <p style="font-weight:bold;width: 120px; margin: 0px; display: flex; align-items: center;">{{ this.GetTraduzioneLabel('Generic','TKN_DATA_RIGHELLO',this.LinguaUtente) }}</p>
          <div style="width: 70%; display: flex; justify-content: space-between">
            <input class="form-control" style="width:55%; display: inline" type="date" v-model="ObjNewRighello.Data">
            <input class="form-control" style="width:40%; display: inline" type="time" v-model="ObjNewRighello.Ora">
          </div>
        </div>
        <div style="width: 100%; display: flex; flex-flow: row wrap; justify-content: space-between; margin-top: 10px">
          <p style="font-weight:bold;width: 150px; margin: 0px; display: flex; align-items: center;">{{ this.GetTraduzioneLabel('Generic','TKN_COLORE_RIGHELLO',this.LinguaUtente) }}</p>
          <label class="form-control" style="width:20%; cursor: pointer; height: 25px; margin: 0px" :style="{'background' : ObjNewRighello.Colore}" @click="ApriPopupColorPicker(ObjNewRighello.Colore, 'background')">&nbsp;</label>
        </div>            
      </div>
    </template>
    <template v-slot:Footer>
      <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:25%" @click="AnnullaPopupAddRighello()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
      <button v-if="ObjNewRighello.Data != '' && ObjNewRighello.Ora != ''" type="button" class="btn btn-success" style="float:right;font-weight:bold;width:25%" @click="ConfermaPopupAddRighello()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
    </template>
  </VUEModal>

  <VUEModal v-if="PopupRemoveRighello" :Titolo="this.GetTraduzioneLabel('Generic','TKN_DATI_RIGHELLO',this.LinguaUtente)" Altezza="140px" Larghezza="500px" :PathLogo="require('@/assets/images/LogoDMS.png')" :Programma="'DMSEW'"
              @onClickChiudiModal="AnnullaPopupRemoveRighello()">
    <template v-slot:Body>
      <div style="font-size:14px; display: flex; flex-flow: row wrap; align-content: center; justify-content: center; align-items: center; margin-top: 15px; padding-left: 30px; padding-right: 30px;">
        <p style="width: 150px; margin: 0px; display: flex; align-items: center;">{{ this.GetTraduzioneLabel('Generic','TKN_SELEZIONA_RIGHELLO',this.LinguaUtente) }}</p>
        <div style="width: 50%; display: flex; justify-content: space-between">
          <select class="form-control" v-model="RighelloToRemove">
            <option :value="''">-</option>
            <option v-for="Righello in GraphData.ListaRighelli" :key="Righello.PrettyDateTime">{{ Righello.PrettyDateTime }}</option>
          </select>
        </div>
      </div>
    </template>
    <template v-slot:Footer>
      <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:25%" @click="AnnullaPopupRemoveRighello()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
      <button v-if="RighelloToRemove != ''" type="button" class="btn btn-success" style="float:right;font-weight:bold;width:25%" @click="ConfermaPopupRemoveRighello()" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
    </template>
  </VUEModal>

  <VUEColorPicker :Popup="PopupColorPicker" Programma="DMSEW" :Colore="ColoreInModifica" @OnClickConfermaPopup="ConfermaColore()" @OnClickChiudiPopup="AnnullaColore()"></VUEColorPicker>

  <div v-if="IsGraficoModulabile" style="height: 20px; width: 20px; background-color: grey; position: relative; top: 3px; left: 98.5%; display: flex; align-content: center; justify-content: center; align-items:center; pointer-events: all; cursor: pointer" @click="MenuImpostazioni = !MenuImpostazioni">
    <a class="fa fa-bars" :title="this.GetTraduzioneLabel('Generic','TKN_IMP_GRAF',this.LinguaUtente)" style="color: white; font-size: 14px;"></a>  
    <div v-if="MenuImpostazioni && IsGraficoModulabile" style="width: 20px; position: absolute; top: 25px; pointer-events: all">
      <div class="ZMGraficoGenericoBottoni" @click="OnClickAdatta">
        <a class="fa fa-arrows" :title="this.GetTraduzioneLabel('Generic','TKN_ADATTA',this.LinguaUtente)" style="color: white; font-size: 14px;"></a>
      </div>
      <div class="ZMGraficoGenericoBottoni" @click="OnClickUdmX">
        <a class="fa fa-sliders" :title="this.GetTraduzioneLabel('Generic','TKN_ASSE_X',this.LinguaUtente)" style="color: white; font-size: 14px;"></a>
      </div>
      <div class="ZMGraficoGenericoBottoni" @click="ApriPopupImpostazioniY">
        <a class="fa fa-sort-amount-asc" :title="this.GetTraduzioneLabel('Generic','TKN_ASSE_Y',this.LinguaUtente)" style="color: white; font-size: 14px;"></a>
      </div>
      <div class="ZMGraficoGenericoBottoni" @click="OnClickAsseTemp">
        <a class="fa fa-sort-alpha-desc" :title="this.GetTraduzioneLabel('VUEFrameComponenteGraficoStorico','TKN_FRM_GRAF_STORICO_ASSE_TEMP',this.LinguaUtente)" style="color: white; font-size: 14px;"></a>
      </div>
      <!-- <div class="ZMGraficoGenericoBottoni" @click="ApriPopupAddRighello">
        <a class="fa fa-pencil" :title="this.GetTraduzioneLabel('Generic','TKN_ADD_RIGHELLO',this.LinguaUtente)" style="color: white; font-size: 14px;"></a>
      </div>
      <div v-if="GraphData.ListaRighelli.length != 0" class="ZMGraficoGenericoBottoni" @click="ApriPopupRemoveRighello()">
        <a class="fa fa-times" :title="this.GetTraduzioneLabel('Generic','TKN_DEL_RIGHELLO',this.LinguaUtente)" style="color: white; font-size: 14px;"></a>
      </div> -->
      <div class="ZMGraficoGenericoBottoni" @click="EsportaComePDF()">
        <a class="fa fa-file-pdf-o" :title="this.GetTraduzioneLabel('Generic','TKN_EXP_PDF',this.LinguaUtente)" style="color: white; font-size: 14px;"></a>
      </div>
    </div>
  </div> 

  <div ref="HintGrafico" v-if="VisualizzaMarkup && MarkupTrovato && ShowHintRoll && this.SelectedMarkup.Color === 'green'" style="background-color: #faf7c3; display: flex; flex-flow: column nowrap; align-content: center; justify-content: center; align-items:center; min-width: 150px; pointer-events: none" 
  :style="{'top' : LabelCoordY + 'px', 'left' : LabelCoordX + 'px', 'position' : 'absolute'}">
    <div style="border-bottom: 2px solid #c9c9c9; width: 100%; font-weight: bold; padding-left: 13px; padding-right: 3px" :style="{'background-color' : Marrone, 'color' : '#faf7c3'}">
      {{ SelectedMarkup.PrettyDate }}
    </div>
    <div v-if="this.SelectedMarkup.Color === 'green' && ShowHintRoll" style="width: 100%; display: flex; flex-flow: column wrap; align-content: center; justify-content: center; align-items:center; padding-left: 13px; padding-right: 3px">
      <div style="width: 100%; display: flex; flex-flow: row wrap;">
        {{ this.GetTraduzioneLabel('Generic','TKN_ROLL',this.LinguaUtente) + ': ' + this.SelectedMarkup.Y + this.GetTraduzioneLabel('UdmGenerali','TKN_SIMBOLO_GRADI',this.LinguaUtente) }}
      </div>
    </div>
  </div>
  <div ref="HintGrafico" v-if="VisualizzaMarkup && MarkupTrovato && ShowHintPitch && this.SelectedMarkup.Color === 'purple'" style="background-color: #faf7c3; display: flex; flex-flow: column nowrap; align-content: center; justify-content: center; align-items:center; min-width: 150px; pointer-events: none" 
  :style="{'top' : LabelCoordY + 'px', 'left' : LabelCoordX + 'px', 'position' : 'absolute'}">
    <div style="border-bottom: 2px solid #c9c9c9; width: 100%; font-weight: bold; padding-left: 13px; padding-right: 3px" :style="{'background-color' : Marrone, 'color' : '#faf7c3'}">
      {{ SelectedMarkup.PrettyDate }}
    </div>
    <div v-if="this.SelectedMarkup.Color === 'purple' && ShowHintPitch" style="width: 100%; display: flex; flex-flow: column wrap; align-content: center; justify-content: center; align-items:center; padding-left: 13px; padding-right: 3px">
      <div style="width: 100%; display: flex; flex-flow: row wrap;">
        {{ this.GetTraduzioneLabel('Generic','TKN_PITCH',this.LinguaUtente) + ': ' + this.SelectedMarkup.Y + this.GetTraduzioneLabel('UdmGenerali','TKN_SIMBOLO_GRADI',this.LinguaUtente) }}
      </div>
    </div>
  </div>
  <div ref="HintGrafico" v-if="VisualizzaMarkup && MarkupTrovato && ShowHintTemp && this.SelectedMarkup.Color === 'red'" style="background-color: #faf7c3; display: flex; flex-flow: column nowrap; align-content: center; justify-content: center; align-items:center; min-width: 150px; pointer-events: none" 
  :style="{'top' : LabelCoordY + 'px', 'left' : LabelCoordX + 'px', 'position' : 'absolute'}">
    <div style="border-bottom: 2px solid #c9c9c9; width: 100%; font-weight: bold; padding-left: 13px; padding-right: 3px" :style="{'background-color' : Marrone, 'color' : '#faf7c3'}">
      {{ SelectedMarkup.PrettyDate }}
    </div>
    <div v-if="this.SelectedMarkup.Color === 'red' && ShowHintTemp" style="width: 100%; display: flex; flex-flow: column wrap; align-content: center; justify-content: center; align-items:center; padding-left: 13px; padding-right: 3px">
      <div style="width: 100%; display: flex; flex-flow: row wrap;">
        {{ this.GetTraduzioneLabel('Generic','TKN_TEMPERATURA',this.LinguaUtente) + ': ' + this.SelectedMarkup.Y + this.GetTraduzioneLabel('UdmGenerali','TKN_CENTIGRADI',this.LinguaUtente) }}
      </div>
    </div>
  </div>
  <div ref="HintGrafico" v-if="VisualizzaMarkup && MarkupTrovato && this.SelectedMarkup.Color === 'blue'" style="background-color: #faf7c3; display: flex; flex-flow: column nowrap; align-content: center; justify-content: center; align-items:center; min-width: 150px; pointer-events: none" 
  :style="{'top' : LabelCoordY + 'px', 'left' : LabelCoordX + 'px', 'position' : 'absolute'}">
    <div style="border-bottom: 2px solid #c9c9c9; width: 100%; font-weight: bold; padding-left: 13px; padding-right: 3px" :style="{'background-color' : Marrone, 'color' : '#faf7c3'}">
      {{ SelectedMarkup.PrettyDate }}
    </div>
    <div v-if="this.SelectedMarkup.Color === 'blue'" style="width: 100%; display: flex; flex-flow: column wrap; align-content: center; justify-content: center; align-items:center; padding-left: 13px; padding-right: 3px">
      <div style="width: 100%; display: flex; flex-flow: row wrap;">
        {{ this.GetTraduzioneLabel('VUEComponenteGraficoCampioniRilevati','TKN_GRAF_CAMP_RIL_FALDA',this.LinguaUtente) + ': ' + this.SelectedMarkup.Y.toFixed(2) + this.GetTraduzioneLabel('UdmGenerali','TKN_METRI_PIANO_CAMPAGNA',this.LinguaUtente) }}
      </div>
    </div>
  </div>
  <div ref="ElementoGrafico">  
    <canvas ref="Canvas" :width="WidthGrafico" :height="HeightGrafico + 50"></canvas>
  </div>      
</template>

<script>
// import { TZGraphMarkup, TZGraphLabelType, TZGraphLine, TZGraphNotchType } from '@/utils/ZGraph.js'
// import { TZGraph } from '@/utils/ZGraph.js'
import MixInsGestioneTraduzioni from '@/utils/MixInsGestioneTraduzioni.js'
import { TZDateFunct } from '@/utils/ZDateFunct'
import VUEModal from '@/utils/VUEModal.vue'
import { TInfoGraphic } from '../../InfoGraphic.js'
import { TZMathFunct } from '@/utils/ZMathFunct'
import { TIPI_UDM_X, SFONDO, SystemInformation, TIPOLOGIA_GRAFICI_STORICI, SPESSORE_LINEE_GRAFICI, INTERVALLI_DI_TEMPO } from '@/SystemInformation'
import MixInsGraficiStorici from '@/views/ContentPages/MixInsGraficiStorici'
import VUEColorPicker from '@/utils/VUEColorPicker.vue'
import { TZGenericFunct } from '@/utils/ZGenericFunct'
import { TZGraphLabelType, TZGraphLine, TZGraphNotchType } from '@/utils/ZGraph.js'


export default 
{
  components: { VUEModal, VUEColorPicker },
  mixins: [ MixInsGestioneTraduzioni, MixInsGraficiStorici ],
  data() 
  {
    return {
              ObjGrafico       : null,
              Marrone          : SFONDO.Marrone,
              TipiUdmX         : TIPI_UDM_X,
              LabelCoordY      : -1,
              LabelCoordX      : -1,
              SelectedMarkup   : null,
              OrientamentoAsse : SystemInformation.OggettoInfoGraficiStorici.OrientamentoAsse,
              ObjNewRighello   : { Data: '', Ora : '', PrettyDateTime: '', Colore: '#000000' },
              PopupImpostazioniAsseY : false,
              MarkupTrovato    : false,
              MenuImpostazioni : false,
              ColoreInModifica : { Colore: '#000000' },
              PopupRemoveRighello : false,
              PopupAsseTemp    : false,
              PopupColorPicker : false,
              PopupAddRighello : false,
              PopupUdmX        : false,
              TipiStorici      : TIPOLOGIA_GRAFICI_STORICI,
              SpessoreGrafico  : SPESSORE_LINEE_GRAFICI,
              IntervalliTempo  : INTERVALLI_DI_TEMPO,
              RighelloToRemove : '',
              ObjDati          : null,
              Stacking         : 10,
              ObjParametriPDF  : {},
              Grafici          : {},
              LinguaUtente     : SystemInformation.UserInformation.Lingua
           }

  },
  props: [ 
            "WidthGrafico", 
            "HeightGrafico", 
            "Modulo", 
            "ObjDal", 
            "ObjAl", 
            "TipoGrafico", 
            "PropsGrafico", 
            "Repaint", 
            "GraficiChange", 
            "PressAdatta",
            "IsPiezometro",
            "IsEstensimetro",
            "VisualizzaMarkup",
            "ShowHintRoll",
            "ShowHintPitch",
            "ShowHintTemp",
            "IsGraficoModulabile",
            "ColorePitch",
            "ColoreRoll",
            "ColoreTemp",
            "ColorePiezo",
            "ColoreDef",
            "OggettoDati",
            "ShowRoll",
            "DescrizioneSitoPDF",
            "ShowPitch",
            "AddDatiPDF",
            "CatenaInfo",
            "ShowTemp"
         ],

  methods:
  {
    Adatta(MaxAsseY, MinAsseY, UdmY, NewUdmX = null)
    {
      //Asse X
      this.ObjGrafico.AxisX.Min           = Date.parse(this.ObjDal.Data + 'T' + (this.ObjDal.Ora < 10? '0' + this.ObjDal.Ora : this.ObjDal.Ora) + ':00')
      this.ObjGrafico.AxisX.Max           = Date.parse(this.ObjAl.Data + 'T' + (this.ObjAl.Ora < 10? '0' + this.ObjAl.Ora : this.ObjAl.Ora) + ':00')
      this.ObjGrafico.AxisX.Max           = this.ObjGrafico.AxisX.Max + TZDateFunct.GetNHoursInTimeStamp(1)
      this.ObjGrafico.ShowFirstMarkup     = true
      if(NewUdmX == null)
      { 
        let AsseTemporale = (Math.abs(this.ObjGrafico.AxisX.Max - this.ObjGrafico.AxisX.Min))
        if(AsseTemporale < this.IntervalliTempo.UnMese)
          this.ObjGrafico.AxisX.NotchDim = TInfoGraphic.GetAdjustedNotchDim(AsseTemporale, 36)
        else this.ObjGrafico.AxisX.NotchDim = this.IntervalliTempo.VentiquattroOre
      }
      else this.ObjGrafico.AxisX.NotchDim = NewUdmX
      
      // this.ObjGrafico.AxisX.OffsetNotch   = this.ObjGrafico.AxisX.NotchDim
      this.ObjGrafico.AxisX.LabelType     = TZGraphLabelType.lblDateTime
      this.ObjGrafico.AxisX.NotchFontSize = 13
      this.GraphData.AxisX.Min            = this.ObjGrafico.AxisX.Min
      this.GraphData.AxisX.Max            = this.ObjGrafico.AxisX.Max
      this.GraphData.AxisX.Udm            = this.ObjGrafico.AxisX.NotchDim

      //Asse Y
      if(MinAsseY == MaxAsseY)
      {
        MaxAsseY = MinAsseY + 10;
        UdmY     = 1
      }

      this.ObjGrafico.AxisY.Min         = MinAsseY
      this.ObjGrafico.AxisY.Max         = MaxAsseY
      this.ObjGrafico.AxisY.NotchDim    = UdmY

      this.GraphData.AxisY.Min          = this.ObjGrafico.AxisY.Min
      this.GraphData.AxisY.Max          = this.ObjGrafico.AxisY.Max
      this.GraphData.AxisY.Udm          = this.ObjGrafico.AxisY.NotchDim

      this.ObjGrafico.AxisY.OffsetNotch = Math.abs(MinAsseY) - TZMathFunct.GetMultiplo(Math.abs(MinAsseY), UdmY, 'Difetto')
      this.ObjGrafico.AxisY.LabelType   = SystemInformation.ConvertDigitToLabelType(TZMathFunct.GetNumeroDecimali(this.ObjGrafico.AxisY.NotchDim))


      //Asse Y Right
      if(this.ObjGrafico.TerzoAsse != null)
      {
        this.ObjGrafico.TerzoAsse.Max           = this.Modulo.MaxAdattamentoAsseTemp
        this.ObjGrafico.TerzoAsse.Min           = this.Modulo.MinAdattamentoAsseTemp
        this.ObjGrafico.TerzoAsse.NotchDim      = this.Modulo.UdmTemp
        this.ObjGrafico.TerzoAsse.OffsetNotch   = 0
        this.ObjGrafico.TerzoAsse.LabelType     = SystemInformation.ConvertDigitToLabelType(TZMathFunct.GetNumeroDecimali(this.ObjGrafico.TerzoAsse.NotchDim))
        this.ObjGrafico.TerzoAsse.NotchColor    = '#ff0000'
        this.ObjGrafico.TerzoAsse.NotchPenStyle = [0, 0]
        this.GraphData.AxisYTemp.Max            = this.ObjGrafico.TerzoAsse.Max
        this.GraphData.AxisYTemp.Min            = this.ObjGrafico.TerzoAsse.Min
        this.GraphData.AxisYTemp.Ampiezza       = this.ObjGrafico.TerzoAsse.NotchDim
      }

      if(this.ObjGrafico.QuartoAsse != null)
      {
        this.ObjGrafico.QuartoAsse.Max           = this.Modulo.MaxAdattamentoAsseYPress
        this.ObjGrafico.QuartoAsse.Min           = this.Modulo.MinAdattamentoAsseYPress
        this.ObjGrafico.QuartoAsse.NotchDim      = Number(this.Modulo.UdmYPress.toFixed(SystemInformation.ConvertDigitToLabelType(TZMathFunct.GetNumeroDecimali(this.Modulo.UdmYPress))))
        this.ObjGrafico.QuartoAsse.OffsetNotch   = 0
        this.ObjGrafico.QuartoAsse.LabelType     = SystemInformation.ConvertDigitToLabelType(TZMathFunct.GetNumeroDecimali(this.ObjGrafico.QuartoAsse.NotchDim))
        this.ObjGrafico.QuartoAsse.NotchColor    = '#ff0000'
        this.ObjGrafico.QuartoAsse.NotchPenStyle = [0, 0]
      }

      if(this.ObjGrafico.QuintoAsse != null)
      {
        this.ObjGrafico.QuintoAsse.Max           = this.Modulo.MaxAdattamentoAsseYDef
        this.ObjGrafico.QuintoAsse.Min           = this.Modulo.MinAdattamentoAsseYDef
        this.ObjGrafico.QuintoAsse.NotchDim      = TZMathFunct.GetMultiplo(this.Modulo.UdmYDef, this.GetUdmToRound(this.Modulo.UdmYDef), 'PiuVicino')
        this.ObjGrafico.QuintoAsse.OffsetNotch   = 0
        this.ObjGrafico.QuintoAsse.LabelType     = SystemInformation.ConvertDigitToLabelType(TZMathFunct.GetNumeroDecimali(this.ObjGrafico.QuintoAsse.NotchDim))
        this.ObjGrafico.QuintoAsse.NotchColor    = '#ff0000'
        this.ObjGrafico.QuintoAsse.NotchPenStyle = [0, 0]
      }

      if (this.Modulo.Disegna)
        setTimeout(() => { this.ObjGrafico.Paint() }, 1)
    },

    GetMaxAxisY()
    {
      let Result = 0
      if(this.Modulo != undefined)
      {
        for(let i = 0; i < this.Modulo.Dati.length; i++)
        {
          if(Result < this.Modulo.Dati[i].Pitch)
            Result = this.Modulo.Dati[i].Pitch
        }
      }
      return Result
    },

    GetMinAxisY()
    {
      let Result = 0
      if(this.Modulo != undefined)
      {
        for(let i = 0; i < this.Modulo.Dati.length; i++)
        {
          if(Result > this.Modulo.Dati[i].Pitch)
            Result = this.Modulo.Dati[i].Pitch
        }
      }
      return Result
    },

    ConvertiMillisecondiInData(Data)
    {
      let NewDate = new Date(Number(Data.toFixed()));
      NewDate.setSeconds(0, 0);
      return NewDate.getTime(); 
    },

    CheckShowMarkup()
    {
      let MostraHighlightMarkup = false
      switch (this.SelectedMarkup.Color)
      {
        case ('green')  : MostraHighlightMarkup = this.ShowHintRoll;  break
        case ('purple') : MostraHighlightMarkup = this.ShowHintPitch; break
        case ('red')    : MostraHighlightMarkup = this.ShowHintTemp;  break
        case ('blue')   : MostraHighlightMarkup = true;               break
      }
      return MostraHighlightMarkup
    },

    GetMousePosOncanvas(event)
    {
      this.MarkupTrovato = false
      if (this.VisualizzaMarkup)
      {
        this.ObjGrafico.AnnullaLastMarkup()
        this.SelectedMarkup = null

        this.SelectedMarkup = this.ObjGrafico.HighlightMarkup(event.offsetX, event.offsetY)
        if (this.SelectedMarkup != null)
        { 
          if(this.CheckShowMarkup())
          {
            this.LabelCoordY = event.layerY
            this.LabelCoordX = event.layerX
            let Data     = new Date(this.ConvertiMillisecondiInData(this.SelectedMarkup.X))
            this.SelectedMarkup.PrettyDate = TZDateFunct.FormatDateTime('dd/mm/yyyy hh:nn', Data) 
            this.MarkupTrovato = true
          }
          else this.ObjGrafico.AnnullaLastMarkup()
        }
      }
    },

    OnClickAdatta()
    {
      this.MixInsOnClickAdattaCampRil(this.PropsGrafico, true)
    },

    OnClickUdmX()
    {
      this.PopupUdmX = true
    },

    ConfermaPopupUdmX()
    {
      this.MixInsConfermaPopupUdmXCampRil(this.GraphData, true)
    },

    AnnullaPopupUdmX()
    {
      this.PopupUdmX = false
    },

    ApriPopupImpostazioniY()
    {
      this.PopupImpostazioniAsseY = true
    },

    ConfermaPopupImpostazioniY()
    {
      this.MixInsConfermaPopupImpostazioniYCampRil(this.GraphData, true)
    },

    AnnullaPopupImpostazioniY()
    {
      this.MixInsAnnullaPopupImpostazioniYCampRil(this.GraphData)
    },

    OnClickAsseTemp()
    {
      this.PopupAsseTemp = true
    },

    AnnullaPopupAsseTemp()
    {
      this.PopupAsseTemp = false
    },

    ConfermaPopupAsseTemp()
    {
      this.MixInsConfermaPopupAsseTemp(this.GraphData, true)
    },

    ApriPopupAddRighello()
    {
      this.PopupAddRighello = true
    },

    ConfermaPopupAddRighello()
    {
      this.MixInsConfermaPopupAddRighelloCampRil(this.GraphData, true)
    },
    
    AnnullaPopupAddRighello()
    {
      this.PopupAddRighello = false
      this.MixInsResetNewRighelloCampRil()
    },

    ApriPopupColorPicker(Colore)
    {
      this.ColoreInModifica.Colore = Colore
      this.PopupColorPicker = true
    },

    ConfermaColore()
    {
      this.ObjNewRighello.Colore = this.ColoreInModifica.Colore
      this.AnnullaColore()
    },

    AnnullaColore()
    {
      this.ColoreInModifica = {}
      this.PopupColorPicker = false
    },

    ApriPopupRemoveRighello()
    {
      this.RighelloToRemove = ''
      this.PopupRemoveRighello = true
    },

    ConfermaPopupRemoveRighello()
    {
      this.MixInsConfermaPopupRemoveRighelloCampRil(this.GraphData, true)
    },

    AnnullaPopupRemoveRighello()
    {
      this.PopupRemoveRighello = false
    },

    EsportaComePDF()
    {
      let ArrayModulo = []
      ArrayModulo.push(TZGenericFunct.GetCopyOfObject(this.Modulo))

      let ArrayOggettoGrafico = []
      ArrayOggettoGrafico.push(TZGenericFunct.GetCopyOfObject(this.GraphData.OggettoGrafico))

      ArrayModulo.forEach(CurrentModulo => {
                                              CurrentModulo.IsPiezometro  = this.IsPiezometro
                                              CurrentModulo.IsEstensimetro = this.IsEstensimetro
                                            });

      this.MixInsEsportaComePDF(ArrayModulo, true, ArrayOggettoGrafico, this.Modulo.Id , this.IsPiezometro, this.IsEstensimetro)
    },

    GetSpostamentoRoll(Lunghezza, CampioneSensore)
    {
      return Lunghezza * Math.sin(TZMathFunct.DegToRad(CampioneSensore));
    },

    CalcolaMillisecondi(UdmX, TipoUdmX)
    {
      let NewUdm = 0
      switch (TipoUdmX)
      {
        case TIPI_UDM_X.Giorni  : {
                                    NewUdm = UdmX * 86_400_000
                                    break
                                  }
        case TIPI_UDM_X.Ore     : {
                                    NewUdm = UdmX * 3_600_000
                                    break
                                  }
        case TIPI_UDM_X.Minuti  : {
                                    NewUdm = UdmX * 60_000
                                    break
                                  }
        default                 : NewUdm = UdmX
      }
      this.ObjGrafico.AxisX.OffsetNotch = 0
      return NewUdm
    },

    Disegna()
    {
      let NewUdmX = null
      if (this.OggettoTotaleSpostamento != undefined && this.OggettoTotaleSpostamento.ModificatoAsseX)
        NewUdmX = this.CalcolaMillisecondi(this.OggettoTotaleSpostamento.AdattaUdmX, this.OggettoTotaleSpostamento.AdattaTipoUdmX)

      if (this.Modulo != undefined && this.Modulo.ModificatoAsseX)
        NewUdmX = this.CalcolaMillisecondi(this.Modulo.AdattaUdmX, this.Modulo.AdattaTipoUdmX)

      this.ObjGrafico.DrawMarkup = this.VisualizzaMarkup

      if(this.IsGraficoModulabile)
      {
        if(this.ShowRoll || this.ShowPitch)
          this.Adatta(this.Modulo.MaxAdattamentoAsseY, this.Modulo.MinAdattamentoAsseY, this.Modulo.UdmY, NewUdmX)
        else
        {
          if(this.IsPiezometro) 
            this.Adatta(this.Modulo.MaxAdattamentoAsseYPress, this.Modulo.MinAdattamentoAsseYPress, this.Modulo.UdmYPress, NewUdmX)
          else this.Adatta(this.Modulo.MaxAdattamentoAsseYDef, this.Modulo.MinAdattamentoAsseYDef, this.Modulo.UdmYDef, NewUdmX)
        }
      }
      else
      {
        if(this.IsPiezometro)
        {
          this.Adatta(this.Modulo.MaxAdattamentoAsseYPress, this.Modulo.MinAdattamentoAsseYPress, this.Modulo.UdmYPress, NewUdmX)
        }
        else 
        {
          if(this.IsEstensimetro)
          {
            this.Adatta(this.Modulo.MaxAdattamentoAsseYDef, this.Modulo.MinAdattamentoAsseYDef, this.Modulo.UdmYDef, NewUdmX)
          }
          else 
          {
            this.Adatta(this.Modulo.MaxAdattamentoAsseY, this.Modulo.MinAdattamentoAsseY, this.Modulo.UdmY, NewUdmX)
          }
        }
      }

      this.InserisciDati()

      if (this.Modulo.Disegna)
        setTimeout(() => { this.ObjGrafico.Paint() })
    },

    InserisciDati()
    {
      this.Grafici = {}
      this.ObjGrafico.ClearAllGroupPoint()

      if(this.IsGraficoModulabile)
      {
        if(this.ShowRoll)
          this.Grafici.Roll  = this.ObjGrafico.AddGroupPoint(1, this.ColoreRoll, this.SpessoreGrafico, this.PropsGrafico.Roll ? true : false)
        if(this.ShowPitch)
          this.Grafici.Pitch = this.ObjGrafico.AddGroupPoint(2, this.ColorePitch, this.SpessoreGrafico, this.PropsGrafico.Pitch ? true : false)
        if(this.ShowTemp)
          this.Grafici.Temp  = this.ObjGrafico.AddGroupPoint(3, this.ColoreTemp, this.SpessoreGrafico, this.PropsGrafico.Temp ? true : false, this.ObjGrafico.TerzoAsse)
        if(this.IsPiezometro)
        {          
          if(this.ShowRoll || this.ShowPitch)
            this.Grafici.Pressione = this.ObjGrafico.AddGroupPoint(4, this.ColorePiezo, this.SpessoreGrafico, true, this.ObjGrafico.QuartoAsse)
          else this.Grafici.Pressione = this.ObjGrafico.AddGroupPoint(4, this.ColorePiezo, this.SpessoreGrafico, true, null, null, false)
          // this.Grafici.Pressione.IdForMultipleAxes = 1
        }
        if(this.IsEstensimetro)
        {
          if(this.ShowRoll || this.ShowPitch || this.IsPiezometro)
            this.Grafici.Deformazione = this.ObjGrafico.AddGroupPoint(5, this.ColoreDef, this.SpessoreGrafico, true, this.ObjGrafico.QuintoAsse)
          else this.Grafici.Deformazione = this.ObjGrafico.AddGroupPoint(5, this.ColoreDef, this.SpessoreGrafico, true, null, null, false)
          // this.Grafici.Deformazione.IdForMultipleAxes = 2
        }

        for (let i = 0; i < this.Modulo.Dati.length; i++)
        {
          let Dato   = this.Modulo.Dati[i]
          let XCoord = Date.parse(Dato.Data)
          if(this.ShowPitch)
            this.Grafici.Pitch.AddPoint(XCoord, Dato.Pitch, '', [], null, null, false, false)
          if(this.ShowRoll)
            this.Grafici.Roll.AddPoint(XCoord, Dato.Roll, '', [], null, null, false, false)
          if(this.ShowTemp)
          {
            if (Dato.Temperatura === null)
            {
              this.Grafici.Temp.AddPoint(XCoord, null, '', [], null, null, false, false)
            }
            else
            {
              if(Dato.Temperatura === 0)
                this.Grafici.Temp.AddPoint(XCoord, 0)
              else this.Grafici.Temp.AddPoint(XCoord, Dato.Temperatura)
            }
          }
          if(this.IsPiezometro)
          {
            if(Dato.Pressione === null)
            {
              this.Grafici.Pressione.AddPoint(XCoord, null, '', [], null, null, false, false)
            }
            else
            {
              if(Dato.Pressione < this.Modulo.PressioneSecco)
              {
                this.Grafici.Pressione.AddPoint(XCoord, null, '', [], null, null, false, false)
              }
              else
              {
                if(Dato.Pressione === 0)
                  this.Grafici.Pressione.AddPoint(XCoord, 0)
                else
              {
                this.Grafici.Pressione.AddPoint(XCoord, Dato.Pressione - this.Modulo.ProfonditaCoda)
              }
              }
            } 
          }
                      
          if(this.IsEstensimetro)
            this.Grafici.Deformazione.AddPoint(XCoord, Dato.Deformazione, '', [], null, null, false, false)
        }
      }
      else
      {
        if(this.IsPiezometro)
        {
          this.Grafici.Pressione = this.ObjGrafico.AddGroupPoint(1, 'blue', this.SpessoreGrafico, true, null, null, false)
          this.Grafici.Temp      = this.ObjGrafico.AddGroupPoint(2, 'red', this.SpessoreGrafico, this.PropsGrafico.Temp ? true : false, this.ObjGrafico.TerzoAsse, null, false)
          
          for (let i = 0; i < this.Modulo.Dati.length; i++)
          {
            let Dato   = this.Modulo.Dati[i]
            let XCoord = Date.parse(Dato.Data)
            
            if(Dato.Pressione === null)
            {
              this.Grafici.Pressione.AddPoint(XCoord, null, '', [], null, null, false, false)
            }
            else
            {
              if(Dato.Pressione < this.Modulo.PressioneSecco)
              {
                this.Grafici.Pressione.AddPoint(XCoord, null, '', [], null, null, false, false)
              }
              else
              {
                if(Dato.Pressione === 0)
                  this.Grafici.Pressione.AddPoint(XCoord, 0)
                else this.Grafici.Pressione.AddPoint(XCoord, Dato.Pressione - this.Modulo.ProfonditaCoda)
              }
            } 

            if (Dato.Temperatura === null)
            {
              this.Grafici.Temp.AddPoint(XCoord, null, '', [], null, null, false, false)
            }
            else
            {
              if(Dato.Temperatura === 0)
                this.Grafici.Temp.AddPoint(XCoord, 0)
              else this.Grafici.Temp.AddPoint(XCoord, Dato.Temperatura)
            } 
          }
        }
        else
        {
          if(this.IsEstensimetro)
          {
            this.Grafici.Deformazione = this.ObjGrafico.AddGroupPoint(1, 'brown', this.SpessoreGrafico, true, null, null, false)
            this.Grafici.Temp         = this.ObjGrafico.AddGroupPoint(2, 'red', this.SpessoreGrafico, this.PropsGrafico.Temp ? true : false, this.ObjGrafico.TerzoAsse, null, false)
  
            for (let i = 0; i < this.Modulo.Dati.length; i++)
            {
              let Dato   = this.Modulo.Dati[i]
              let XCoord = Date.parse(Dato.Data)
              
              if(Dato.Deformazione === null)
              {
                this.Grafici.Deformazione.AddPoint(XCoord, null, '', [], null, null, false, false)
              }
              else
              {
                if (Dato.Deformazione === 0)
                  this.Grafici.Deformazione.AddPoint(XCoord, 0)
                else this.Grafici.Deformazione.AddPoint(XCoord, Dato.Deformazione)
              }

              if(Dato.Temperatura === null)
              {
                this.Grafici.Temp.AddPoint(XCoord, null, '', [], null, null, false, false)
              }
              else
              {
                if(Dato.Temperatura === 0)
                  this.Grafici.Temp.AddPoint(XCoord, 0)
                else this.Grafici.Temp.AddPoint(XCoord, Dato.Temperatura)
              }
            }
          }
          else
          {
            this.Grafici.Roll  = this.ObjGrafico.AddGroupPoint(1, 'green', this.SpessoreGrafico, this.PropsGrafico.Roll ? true : false, null, null, false)
            this.Grafici.Pitch = this.ObjGrafico.AddGroupPoint(2, 'purple', this.SpessoreGrafico, this.PropsGrafico.Pitch ? true : false, null, null, false)
            this.Grafici.Temp  = this.ObjGrafico.AddGroupPoint(3, 'red', this.SpessoreGrafico, this.PropsGrafico.Temp ? true : false, this.ObjGrafico.TerzoAsse, null, false)

            for (let i = 0; i < this.Modulo.Dati.length; i++)
            {              
              let Dato   = this.Modulo.Dati[i]
              let XCoord = Date.parse(Dato.Data)
              if(Dato.Pitch === null)
              {
                this.Grafici.Pitch.AddPoint(XCoord, null, '', [], null, null, false, false)
              }
              else
              {
                if (Dato.Pitch === 0)
                  this.Grafici.Pitch.AddPoint(XCoord, 0)
                else this.Grafici.Pitch.AddPoint(XCoord, Dato.Pitch)
              } 

              if(Dato.Roll === null)
              {
                this.Grafici.Roll.AddPoint(XCoord, null, '', [], null, null, false, false)
              }
              else
              {
                if (Dato.Roll === 0)
                  this.Grafici.Roll.AddPoint(XCoord, 0)
                else this.Grafici.Roll.AddPoint(XCoord, Dato.Roll)
              } 

              if(Dato.Temperatura === null)
              {
                this.Grafici.Temp.AddPoint(XCoord, null, '', [], null, null, false, false)
              }
              else
              {
                if (Dato.Temperatura === 0)
                  this.Grafici.Temp.AddPoint(XCoord, 0)
                else this.Grafici.Temp.AddPoint(XCoord, Dato.Temperatura)
              } 
                
            }
          }
        }
      }
    },

    DoRepaint()
    {
      if(this.IsGraficoModulabile)
      {
        if(this.ShowRoll)
          this.Grafici.Roll.Visible  = this.PropsGrafico.Roll
        if(this.ShowPitch)
          this.Grafici.Pitch.Visible = this.PropsGrafico.Pitch
        if(this.ShowTemp)
          this.Grafici.Temp.Visible  = this.PropsGrafico.Temp
      }
      else
      {
        this.Grafici.Temp.Visible  = this.PropsGrafico.Temp
        if(!this.IsPiezometro && !this.IsEstensimetro)
        {
          this.Grafici.Roll.Visible  = this.PropsGrafico.Roll
          this.Grafici.Pitch.Visible = this.PropsGrafico.Pitch
        }
      } 

      this.ObjGrafico.ClearListaRighelli()
      for (let i = 0; i < this.PropsGrafico.ListaRighelli.length; i++)
      {
        let Righello                = this.PropsGrafico.ListaRighelli[i]
        let AsseRighello            = this.ObjGrafico.AddRighello()
        AsseRighello.Color          = Righello.Colore
        AsseRighello.ParalleloAsseX = false
        AsseRighello.DistanceFromY  = Date.parse(Righello.DateTime)
      }
      if (this.PropsGrafico.AxisX.Modificato)
      {
        let NewUdm = 0
        switch (this.PropsGrafico.AxisX.TipoUdmX)
        {
          case TIPI_UDM_X.Giorni  : {
                                      NewUdm = this.PropsGrafico.AxisX.UdmX * 86_400_000
                                      break
                                    }
          case TIPI_UDM_X.Ore     : {
                                      NewUdm = this.PropsGrafico.AxisX.UdmX * 3_600_000
                                      break
                                    }
          case TIPI_UDM_X.Minuti  : {
                                      NewUdm = this.PropsGrafico.AxisX.UdmX * 60_000
                                      break
                                    }
          default                 : NewUdm = this.PropsGrafico.AxisX.UdmX
        }
        this.ObjGrafico.AxisX.OffsetNotch = 0
        this.ObjGrafico.AxisX.NotchDim    = NewUdm
      }

      if(this.PropsGrafico.AxisY.Modificato)
      {
        this.ObjGrafico.AxisY.Max         = this.PropsGrafico.AxisY.Max
        this.ObjGrafico.AxisY.Min         = this.PropsGrafico.AxisY.Min
        this.ObjGrafico.AxisY.NotchDim    = this.PropsGrafico.AxisY.Udm
        this.ObjGrafico.AxisY.OffsetNotch = 0
        this.ObjGrafico.AxisY.LabelType   = SystemInformation.ConvertDigitToLabelType(TZMathFunct.GetNumeroDecimali(this.ObjGrafico.AxisY.NotchDim))

        // this.PropsGrafico.AxisY.Modificato = false
      }
      if(this.PropsGrafico.AxisYTemp.Modificato)
      {
        this.ObjGrafico.TerzoAsse.Max         = this.PropsGrafico.AxisYTemp.Max
        this.ObjGrafico.TerzoAsse.Min         = this.PropsGrafico.AxisYTemp.Min
        this.ObjGrafico.TerzoAsse.NotchDim    = this.PropsGrafico.AxisYTemp.Ampiezza
        this.ObjGrafico.TerzoAsse.OffsetNotch = 0
        // this.PropsGrafico.AxisY.Modificato = false
      }
      if(this.IsGraficoModulabile)
      {
        if(this.PropsGrafico.AxisYPress.Modificato)
        {
          this.ObjGrafico.QuintoAsse.Max         = this.PropsGrafico.AxisYPress.Max
          this.ObjGrafico.QuintoAsse.Min         = this.PropsGrafico.AxisYPress.Min
          this.ObjGrafico.QuintoAsse.NotchDim    = this.PropsGrafico.AxisYPress.Ampiezza
          this.ObjGrafico.QuintoAsse.OffsetNotch = 0
        }
        if(this.PropsGrafico.AxisYDef.Modificato)
        {
          this.ObjGrafico.QuartoAsse.Max         = this.PropsGrafico.AxisYDef.Max
          this.ObjGrafico.QuartoAsse.Min         = this.PropsGrafico.AxisYDef.Min
          this.ObjGrafico.QuartoAsse.NotchDim    = this.PropsGrafico.AxisYDef.Ampiezza
          this.ObjGrafico.QuartoAsse.OffsetNotch = 0
        }
      }

      if (this.Modulo.Disegna)
        setTimeout(() => { this.ObjGrafico.Paint()})
    }
  },

  computed:
  {
    DisegnaGrafico:
    {
      get()
      {
        if (this.Modulo != undefined)
          return this.Modulo.Disegna
        else return false
      }
    },

    GraphData:
    {
      get()
      {
        return this.PropsGrafico
      }
    },
    
    CurrentModulo :
    {
      get()
      {
        return this.Modulo
      }
    },
    
    InfoCatena:
    {
      get()
      {
        return this.CatenaInfo
      }
    }
  },

  watch:
  {
    AddDatiPDF:
    {
      handler(NewValue)
      {
        if (NewValue != 0)
        {
          this.InfoCatena.DatiPDF.push(this.MixInsGetDatiPerPDF(true, this.Modulo, TZGenericFunct.GetCopyOfObject(this.GraphData.OggettoGrafico)))
        }
      }
    },

    DisegnaGrafico:
    {
      handler()
      {
        this.Disegna()
      }
    },

    Repaint:
    {
      handler()
      {
        this.DoRepaint()
      }
    },

    GraficiChange:
    {
      handler()
      {
        this.Disegna()
      }
    },

    PressAdatta:
    {
      handler()
      {
        this.Disegna()
      }
    }
  },

  mounted()
  {
    if(this.OggettoDati != null)
    {
      this.ObjDati = this.OggettoDati
      this.ObjDati.TipoGrafico = this.TipiStorici.CAMPIONI_RILEVATI
    }
    this.ObjGrafico  = new TZGraphLine(this.$refs.Canvas)
    this.GraphData.OggettoGrafico = this.ObjGrafico
    this.ObjGrafico.DrawMarkup = this.VisualizzaMarkup
    this.ObjGrafico.MarkupWidth = 6
    this.ObjGrafico.AxisX.NotchPenWidth = 1
    this.ObjGrafico.AxisY.NotchPenWidth = 1
    this.ObjGrafico.AxisX.NotchColor    = 'grey'
    this.ObjGrafico.AxisY.NotchColor    = 'grey'
    
    // this.ObjGrafico  = new TZGraph(this.$refs.Canvas)
    
    if(this.IsGraficoModulabile)
    {
      this.ObjGrafico.VerticalLabelAxisX  = true
      // this.ObjGrafico.AxisX.AddLabel('Data')
      if(this.ShowRoll || this.ShowPitch)
        this.ObjGrafico.AxisY.CenterLabel = '', this.GetTraduzioneLabel('Generic','TKN_INCLINAZIONI',this.LinguaUtente) + ' [' + this.GetTraduzioneLabel('UdmGenerali','TKN_SIMBOLO_GRADI',this.LinguaUtente) + ']'
      else
      {
        if(this.IsPiezometro)
          this.ObjGrafico.AxisY.CenterLabel = ' ' + this.GetTraduzioneLabel('VUEComponenteGraficoCampioniRilevati','TKN_GRAF_CAMP_RIL_FALDA',this.LinguaUtente) + ' [' + this.GetTraduzioneLabel('UdmGenerali','TKN_METRI_PIANO_CAMPAGNA',this.LinguaUtente) + ']'
        else this.ObjGrafico.AxisY.CenterLabel = this.GetTraduzioneLabel('Generic','TKN_DEFORMAZIONI',this.LinguaUtente) + ' [' + this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIMETRI',this.LinguaUtente) + ']'
      }
      this.ObjGrafico.AxisX.NotchType      = TZGraphNotchType.notStandard
      this.ObjGrafico.AxisY.NotchType      = TZGraphNotchType.notStandard
      this.ObjGrafico.AxisY.LabelType      = TZGraphLabelType.lblDecimi

      if(this.ObjGrafico.AxisY.NotchDim != undefined)
        this.ObjGrafico.AxisY.LabelType    = SystemInformation.ConvertDigitToLabelType(TZMathFunct.GetNumeroDecimali(this.ObjGrafico.AxisY.NotchDim))

      this.ObjGrafico.AxisX.LabelType      = TZGraphLabelType.lblDateTime
      this.ObjGrafico.AxisX.NotchFontSize  = 13
      this.ObjGrafico.AxisY.NotchFontSize  = 13

      this.ObjGrafico.__Margins.MinBottom += 60
      this.ObjGrafico.__Margins.MinLeft   += 30

      this.ObjGrafico.TerzoAsse = this.ObjGrafico.AddOtherAxis()
      this.ObjGrafico.TerzoAsse.FontSize      = 13;
      this.ObjGrafico.TerzoAsse.CenterLabel = ' ' + this.GetTraduzioneLabel('Generic','TKN_TEMPERATURA',this.LinguaUtente) + ' [' + this.GetTraduzioneLabel('UdmGenerali','TKN_CENTIGRADI',this.LinguaUtente) + ']'
      this.ObjGrafico.TerzoAsse.LabelOnGraph = true
      this.ObjGrafico.TerzoAsse.NotchType  = TZGraphNotchType.notStandard
      if(this.ColoreTemp.startsWith('rgb'))
        this.ObjGrafico.TerzoAsse.Color    = TZGenericFunct.GetHexColorFromRGB(this.ColoreTemp)
      else this.ObjGrafico.TerzoAsse.Color = this.ColoreTemp
      this.ObjGrafico.TerzoAsse.LabelType  = TZGraphLabelType.lblDecimi
      if(this.ObjGrafico.TerzoAsse.NotchDim != undefined)
        this.ObjGrafico.TerzoAsse.LabelType    = SystemInformation.ConvertDigitToLabelType(TZMathFunct.GetNumeroDecimali(this.ObjGrafico.TerzoAsse.NotchDim))
      this.ObjGrafico.TerzoAsse.NotchFontSize = 13

      if(this.IsPiezometro && this.ShowRoll && this.ShowPitch)
      { 
        this.ObjGrafico.MultipleDrawingAxis = true
        this.ObjGrafico.QuartoAsse = this.ObjGrafico.AddOtherAxis()
        this.ObjGrafico.QuartoAsse.LabelOnGraph = true
        this.ObjGrafico.QuartoAsse.NotchType  = TZGraphNotchType.notStandard
        this.ObjGrafico.QuartoAsse.LabelType  = TZGraphLabelType.lblDecimi
        if(this.ObjGrafico.QuartoAsse.NotchDim != undefined)
          this.ObjGrafico.QuartoAsse.LabelType = SystemInformation.ConvertDigitToLabelType(TZMathFunct.GetNumeroDecimali(this.ObjGrafico.QuartoAsse.NotchDim))
        this.ObjGrafico.QuartoAsse.NotchFontSize = 13
        if(this.ColorePiezo.startsWith('rgb'))
          this.ObjGrafico.QuartoAsse.Color    = TZGenericFunct.GetHexColorFromRGB(this.ColorePiezo)
        else this.ObjGrafico.QuartoAsse.Color = this.ColorePiezo
        this.ObjGrafico.QuartoAsse.CenterLabel = ' ' + this.GetTraduzioneLabel('VUEComponenteGraficoCampioniRilevati','TKN_GRAF_CAMP_RIL_FALDA',this.LinguaUtente) + ' [' + this.GetTraduzioneLabel('UdmGenerali','TKN_METRI_PIANO_CAMPAGNA',this.LinguaUtente) + ']'
        this.ObjGrafico.__Margins.MinRight     -=  70
      }
      if(this.IsEstensimetro && ((this.ShowRoll && this.ShowPitch) || this.IsPiezometro))
      {
        this.ObjGrafico.MultipleDrawingAxis = true
        this.ObjGrafico.QuintoAsse = this.ObjGrafico.AddOtherAxis()
        this.ObjGrafico.QuintoAsse.CenterLabel = this.GetTraduzioneLabel('Generic','TKN_DEFORMAZIONI',this.LinguaUtente) + ' [' + this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIMETRI',this.LinguaUtente) + ']'
        this.ObjGrafico.QuintoAsse.LabelOnGraph = true
        this.ObjGrafico.QuintoAsse.NotchType  = TZGraphNotchType.notStandard
        this.ObjGrafico.QuintoAsse.LabelType  = TZGraphLabelType.lblDecimi
        if(this.ObjGrafico.QuintoAsse.NotchDim != undefined)
          this.ObjGrafico.QuintoAsse.LabelType = SystemInformation.ConvertDigitToLabelType(TZMathFunct.GetNumeroDecimali(this.ObjGrafico.QuintoAsse.NotchDim))
        this.ObjGrafico.QuintoAsse.NotchFontSize = 13
        if(this.ColoreDef.startsWith('rgb'))
          this.ObjGrafico.QuintoAsse.Color    = TZGenericFunct.GetHexColorFromRGB(this.ColoreDef)
        else this.ObjGrafico.QuintoAsse.Color = this.ColoreDef
        if(!this.IsPiezometro)
          this.ObjGrafico.__Margins.MinRight     -=  70
      }
    }
    else
    {
      if(!this.IsPiezometro && !this.IsEstensimetro)
      { 
        this.ObjGrafico.VerticalLabelAxisX  = true
        // this.ObjGrafico.AxisX.AddLabel('Data')
        this.ObjGrafico.AxisY.CenterLabel    = this.GetTraduzioneLabel('Generic','TKN_INCLINAZIONI',this.LinguaUtente) + ' [' + this.GetTraduzioneLabel('UdmGenerali','TKN_SIMBOLO_GRADI',this.LinguaUtente) + ']'
        this.ObjGrafico.AxisX.NotchType      = TZGraphNotchType.notStandard
        this.ObjGrafico.AxisY.NotchType      = TZGraphNotchType.notStandard
        this.ObjGrafico.AxisY.LabelType      = TZGraphLabelType.lblDecimi
        if(this.ObjGrafico.AxisY.NotchDim != undefined)
          this.ObjGrafico.AxisY.LabelType    = SystemInformation.ConvertDigitToLabelType(TZMathFunct.GetNumeroDecimali(this.ObjGrafico.AxisY.NotchDim))
        this.ObjGrafico.AxisX.LabelType      = TZGraphLabelType.lblDateTime
        this.ObjGrafico.AxisX.NotchFontSize  = 13
        this.ObjGrafico.AxisY.NotchFontSize  = 13
        this.ObjGrafico.__Margins.MinBottom += 60
        this.ObjGrafico.__Margins.MinLeft   += 25
  
        this.ObjGrafico.TerzoAsse = this.ObjGrafico.AddOtherAxis()
        this.ObjGrafico.TerzoAsse.FontSize      = 13;
        this.ObjGrafico.TerzoAsse.CenterLabel = ' ' + this.GetTraduzioneLabel('Generic','TKN_TEMPERATURA',this.LinguaUtente) + ' [' + this.GetTraduzioneLabel('UdmGenerali','TKN_CENTIGRADI',this.LinguaUtente) + ']'
        this.ObjGrafico.TerzoAsse.LabelOnGraph = true
        this.ObjGrafico.TerzoAsse.NotchType  = TZGraphNotchType.notStandard
        this.ObjGrafico.TerzoAsse.LabelType  = TZGraphLabelType.lblDecimi
        if(this.ObjGrafico.TerzoAsse.NotchDim != undefined)
          this.ObjGrafico.TerzoAsse.LabelType    = SystemInformation.ConvertDigitToLabelType(TZMathFunct.GetNumeroDecimali(this.ObjGrafico.TerzoAsse.NotchDim))

        this.ObjGrafico.TerzoAsse.NotchFontSize = 13
      }
      else
      {
        if(this.IsPiezometro)
        {
          this.ObjGrafico.VerticalLabelAxisX  = true
          // this.ObjGrafico.AxisX.AddLabel('Data')
          //this.ObjGrafico.AxisY.AddLabel('',' ' + this.GetTraduzioneLabel('VUEComponenteGraficoCampioniRilevati','TKN_GRAF_CAMP_RIL_FALDA',this.LinguaUtente) + ' [' + this.GetTraduzioneLabel('UdmGenerali','TKN_METRI_PIANO_CAMPAGNA',this.LinguaUtente) + ']')
          this.ObjGrafico.AxisY.CenterLabel   = this.GetTraduzioneLabel('VUEComponenteGraficoCampioniRilevati','TKN_GRAF_CAMP_RIL_FALDA',this.LinguaUtente) + ' [' + this.GetTraduzioneLabel('UdmGenerali','TKN_METRI_PIANO_CAMPAGNA',this.LinguaUtente) + ']'
          this.ObjGrafico.AxisX.NotchType     = TZGraphNotchType.notStandard
          this.ObjGrafico.AxisY.NotchType     = TZGraphNotchType.notStandard
          this.ObjGrafico.AxisY.LabelType     = TZGraphLabelType.lblDecimi
          if(this.ObjGrafico.AxisY.NotchDim != undefined)
            this.ObjGrafico.AxisY.LabelType    = SystemInformation.ConvertDigitToLabelType(TZMathFunct.GetNumeroDecimali(this.ObjGrafico.AxisY.NotchDim))
          this.ObjGrafico.AxisX.LabelType     = TZGraphLabelType.lblDateTime
          this.ObjGrafico.AxisY.NotchFontSize = 13
          this.ObjGrafico.AxisX.NotchFontSize = 13
          this.ObjGrafico.__Margins.MinBottom += 45
          this.ObjGrafico.__Margins.MinLeft   += 25
          this.ObjGrafico.RightAxisY = true
          this.ObjGrafico.TerzoAsse = this.ObjGrafico.AddOtherAxis()
          this.ObjGrafico.TerzoAsse.FontSize      = 13;
          this.ObjGrafico.TerzoAsse.CenterLabel = (' ' + this.GetTraduzioneLabel('Generic','TKN_TEMPERATURA',this.LinguaUtente) + ' [' + this.GetTraduzioneLabel('UdmGenerali','TKN_CENTIGRADI',this.LinguaUtente) + ']')
          this.ObjGrafico.TerzoAsse.NotchType = TZGraphNotchType.notStandard
          this.ObjGrafico.TerzoAsse.LabelType = TZGraphLabelType.lblDecimi   
          if(this.ObjGrafico.TerzoAsse.NotchDim != undefined)
            this.ObjGrafico.TerzoAsse.LabelType    = SystemInformation.ConvertDigitToLabelType(TZMathFunct.GetNumeroDecimali(this.ObjGrafico.TerzoAsse.NotchDim))

          this.ObjGrafico.TerzoAsse.NotchFontSize = 13
        }
        else
        {
          if(this.IsEstensimetro)
          {
            this.ObjGrafico.VerticalLabelAxisX   = true
            // this.ObjGrafico.AxisX.AddLabel('Data')
            this.ObjGrafico.AxisY.CenterLabel = this.GetTraduzioneLabel('Generic','TKN_DEFORMAZIONI',this.LinguaUtente) + ' [' + this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIMETRI',this.LinguaUtente) + ']'
            this.ObjGrafico.AxisX.NotchType      = TZGraphNotchType.notStandard
            this.ObjGrafico.AxisY.NotchType      = TZGraphNotchType.notStandard
            this.ObjGrafico.AxisY.LabelType      = TZGraphLabelType.lblDecimi
            if(this.ObjGrafico.AxisY.NotchDim != undefined)
              this.ObjGrafico.AxisY.LabelType    = SystemInformation.ConvertDigitToLabelType(TZMathFunct.GetNumeroDecimali(this.ObjGrafico.AxisY.NotchDim))
            this.ObjGrafico.AxisX.LabelType      = TZGraphLabelType.lblDateTime
            this.ObjGrafico.AxisX.NotchFontSize  = 13
            this.ObjGrafico.AxisY.NotchFontSize = 13
            // this.ObjGrafico.AxisX.FontSize      = 15
            this.ObjGrafico.__Margins.MinBottom += 45
            this.ObjGrafico.__Margins.MinLeft   += 25
  
            this.ObjGrafico.TerzoAsse            = this.ObjGrafico.AddOtherAxis()
            this.ObjGrafico.TerzoAsse.FontSize      = 13;
            this.ObjGrafico.TerzoAsse.CenterLabel = ' ' + this.GetTraduzioneLabel('Generic','TKN_TEMPERATURA',this.LinguaUtente) + ' [' + this.GetTraduzioneLabel('UdmGenerali','TKN_CENTIGRADI',this.LinguaUtente) + ']'
            this.ObjGrafico.TerzoAsse.NotchType  = TZGraphNotchType.notStandard
            this.ObjGrafico.TerzoAsse.LabelType  = TZGraphLabelType.lblDecimi
            if(this.ObjGrafico.TerzoAsse.NotchDim != undefined)
              this.ObjGrafico.TerzoAsse.LabelType    = SystemInformation.ConvertDigitToLabelType(TZMathFunct.GetNumeroDecimali(this.ObjGrafico.TerzoAsse.NotchDim))
            this.ObjGrafico.TerzoAsse.NotchFontSize = 13
            // this.ObjGrafico.TerzoAsse.FontSize      = 15
          }
        }
      }
    }

    this.ObjGrafico.AxisY.FontSize       = 13
    
    this.Disegna()
    this.$refs.Canvas.addEventListener('mousemove', this.GetMousePosOncanvas)
  },
  
  beforeUnmount()
  {
    this.$refs.Canvas.removeEventListener('mousemove', this.GetMousePosOncanvas)
  }

}
</script>